angular.module('components.caArticleVariantsGridCell', [])
    .component('caArticleVariantsGridCell', {
        templateUrl: 'main/product/articles/article/components/articlevariantsgridcell.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            articleVariant: '=',
            articleVariants: '=',
            articleCollections: '<',
            gridEditType: '<',
            onArticleVariantUpdated: '&',
            changeCount: '=',
            disabled: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.dataType = '';
    vm.handleMultipleArticleVariants = false;
    vm.inputBoxDisplayValue = '';

    vm.inputValueChanged = inputValueChanged;

    function onInit() {
        if (vm.dataType === undefined || vm.dataType === '') {
            vm.dataType = 'number'; //Default for input fields is number, but datatype for each tab is set in articlevariantsgrid.component.js
        }

        if (vm.articleVariant === undefined && vm.articleVariants.length !== 0) {
            vm.handleMultipleArticleVariants = true;
        } else {
            vm.handleMultipleArticleVariants = false;
        }

        reloadInputBoxValue();

        $scope.$watch(function() { return vm.changeCount; }, function(newValue, oldValue) {
            if (newValue !== oldValue) {
                reloadInputBoxValue();
            }
        });
    }

    function onChanges(changes) {
        if (changes.changeCount) {
            reloadInputBoxValue();
        }
        if (changes.gridEditType) {
            vm.dataType = vm.gridEditType.dataType;
            reloadInputBoxValue();
            if (vm.handleMultipleArticleVariants) {
                vm.inputBoxDisplayValue = undefined;
            }
        }
    }
    function onDestroy() {}

    function reloadInputBoxValue() {
        if (!vm.handleMultipleArticleVariants && vm.articleVariant && vm.articleVariant[vm.gridEditType.value]) {
            vm.inputBoxDisplayValue = vm.articleVariant[vm.gridEditType.value];
        } else if (!vm.handleMultipleArticleVariants && vm.dataType === 'number') {
            vm.inputBoxDisplayValue = '0';
        } else if (!vm.handleMultipleArticleVariants && vm.dataType === 'boolean') {
            vm.inputBoxDisplayValue = false;
        } else if (!vm.handleMultipleArticleVariants && vm.dataType === 'disabled') {
            vm.inputBoxDisplayValue = '';
        }
    }

    function inputValueChanged() {
        if (vm.handleMultipleArticleVariants) {
            _.forEach(vm.articleVariants, function(articleVariant) {
                articleVariant[vm.gridEditType.value] = vm.inputBoxDisplayValue;
            });
        } else {
            vm.articleVariant[vm.gridEditType.value] = vm.inputBoxDisplayValue;
        }
        vm.changeCount += 1;
    }
}
